import React from 'react'

const Heading = ({attrs = {}}) => {
	// Gestion des props manquantes avec valeurs par défaut
	const safeAttrs = {
		alignment: attrs?.alignment || 'left',
		headingContent: attrs?.headingContent || 'Titre de section'
	}

	// Vérification que l'alignement est valide
	const validAlignment = ['left', 'center', 'right'].includes(safeAttrs.alignment) ? safeAttrs.alignment : 'left'

	return (
		<div className={`block-heading text-${validAlignment}`}>
			<div className="block-heading-content" dangerouslySetInnerHTML={{__html: safeAttrs.headingContent}} />
		</div>
	)
}

export default Heading
